import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import useGeocode from '@cobliteam/hooks/src/useEntity/useGeocode';
import Skeleton from '@cobliteam/ui/components/Skeleton';
import Timeline, { TimelineContent, TimelineIcon, TimelineItem } from '@cobliteam/ui/components/Timeline';
import { useCallback, useEffect, useState } from 'react';

interface PathAddressDetailsProps {
  path: Path;
}

const PathAddressDetails = ({ path }: PathAddressDetailsProps) => {
  const { latitude, longitude, startLatitude, startLongitude, endLatitude, endLongitude, type } = path;
  const isTrip = type === 'trip';

  const { getAddress } = useGeocode();
  const memoizedGetAddress = useCallback(getAddress, []);

  const [startAddress, setStartAddress] = useState('');
  const [endAddress, setEndAddress] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchAddresses = async () => {
      setIsLoading(true);

      if (latitude && longitude) {
        const address = await memoizedGetAddress({ lat: latitude, lng: longitude });
        setStartAddress(address);
      }

      if (startLatitude && startLongitude) {
        const address = await memoizedGetAddress({ lat: startLatitude, lng: startLongitude });
        setStartAddress(address);
      }

      if (endLatitude && endLongitude) {
        const address = await memoizedGetAddress({ lat: endLatitude, lng: endLongitude });
        setEndAddress(address);
      }

      setIsLoading(false);
    };

    fetchAddresses();
  }, [latitude, longitude, startLatitude, startLongitude, endLatitude, endLongitude, memoizedGetAddress]);

  return (
    <Timeline>
      <TimelineItem separatorClassName='bg-primary'>
        {isTrip ? <TimelineIcon color='primary'>A</TimelineIcon> : <TimelineIcon icon='pause' color='primary' />}
        <TimelineContent>{isLoading ? <Skeleton className='h-4 w-full' /> : startAddress}</TimelineContent>
      </TimelineItem>

      {isTrip && (
        <TimelineItem separatorClassName='bg-primary'>
          <TimelineIcon color='primary'>B</TimelineIcon>
          <TimelineContent>{isLoading ? <Skeleton className='h-4 w-full' /> : endAddress}</TimelineContent>
        </TimelineItem>
      )}
    </Timeline>
  );
};

export default PathAddressDetails;
